import { EDeviceType, getThemeBreakpointByDeviceType } from "@utils/getThemeBreakpointByDeviceType";
import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
    containerMarketingPreferences: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
    },
    itemMarketingPreferences: {
        padding: theme.spacing(2.5),
        backgroundColor: theme.palette.background.dark,
        marginBottom: theme.spacing(1.25),
        borderRadius: theme.spacing(1),
    },
    collapsableTop: {
        display: "flex",
        justifyContent: "space-between",
    },
    collapsableChild: {
        display: "flex",
        maxWidth: 526,
        backgroundColor: theme.palette.background.dark,
        paddingTop: theme.spacing(1.5),
        justifyContent: "space-between",
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE)]: {
            flexDirection: "column",
            width: "100%",
            gap: theme.spacing(2.25),
        },
    },
}));
